{
  "common": {
    "notAvailable": "N/A",
    "free": "Free",
    "storeCredit": "Store Credit",
    "itemCount": {
      "one": "{count} item",
      "other": "{count} items"
    },
    "nextItem": "Next item",
    "continueToReturnMethod": "Continue to Return Method",
    "returnMethod": "Return Method",
    "paymentMethodRequired": "Payment method required"
  },
  "errorBoundary": {
    "title": "Something went wrong.",
    "tryAgain": "Try again"
  },
  "noReturnPolicy": {
    "title": "Return Not Possible",
    "heading": "Order #{number} is not configured for return.",
    "contactMerchant": "Please contact the merchant directly for assistance."
  },
  "confirmationModal": {
    "confirm": "Remove this item",
    "cancel": "No, don’t"
  },
  "removeItem": {
    "title": "Do you want to remove this item from your return?"
  },
  "itemSelection": {
    "title": "Which item(s) would you like to return or replace?",
    "noItems": "No returnable items found.",
    "returnButton": "Return",
    "returnItems": {
      "one": "Return {count} item",
      "other": "Return {count} items"
    },
    "price": "Price: {price}",
    "quantityToReturn": "Number of items to return:",
    "partialEligibility": "Partial Eligibility",
    "removeOne": "Remove one item",
    "addOne": "Add one item"
  },
  "reasonSelection": {
    "title": "What is the reason for the return or replacement?"
  },
  "ineligibleReason": {
    "heading": "This item can't be returned for this reason",
    "youSelected": "You selected “{reason}”",
    "continueWithOtherItems": "Continue with my other items",
    "backToMyItems": "Back to my items",
    "chooseDifferentReason": "Choose a different reason"
  },
  "uploadProof": {
    "title": "Upload proof",
    "notesPromptRequired": "{prompt} (required)",
    "notesPromptOptional": "{prompt} (optional)",
    "addCommentRequired": "Add comment (required)",
    "addCommentOptional": "Add comment (optional)",
    "uploadFailed": "Upload failed",
    "intro": "Please share information about the return.",
    "removeFile": "Remove file",
    "uploadFiles": "Upload files",
    "uploadFilesRequired": "Upload files (required)",
    "maxFileSize": "Maximum upload file size: 15 MB (30 seconds of video)"
  },
  "resolutionSelection": {
    "title": "How can we make this right?",
    "recommended": "Recommended",
    "getItNow": "Get it now",
    "bonusCredit": "Enjoy additional {amount} in bonus {creditName}!",
    "receiveBeforeShippingReturn": "Receive your {resolution} before shipping your return.",
    "optionToReceiveBeforeShipping": "Option to receive your {resolution} before shipping."
  },
  "resolutionNamesInSentence": {
    "refund": "refund",
    "replacement": "replacement",
    "exchange": "exchange"
  },
  "storeCreditNamesInSentence": {
    "store_credit": "store credit",
    "gift_card": "gift card"
  },
  "resolutionDescriptions": {
    "refund": "Receive a refund to the original payment method for the item.",
    "replacement": "Receive a brand-new item.",
    "storeCredit": "Receive {creditName} to be used for your next order with us.",
    "exchangeAnyItem": "Exchange for a different item.",
    "exchangeVariant": "Exchange for a different variation of the item."
  },
  "exchangeVariantSelection": {
    "title": "What would you like to exchange for?"
  },
  "exchangeProductBrowser": {
    "chooseVariant": "Choose a variant",
    "chooseProduct": "Choose a product to exchange"
  },
  "exchangeRedirectConfirmation": {
    "notWhatYouWanted": "Not what you wanted?",
    "chooseDifferentItem": "Choose a different item"
  },
  "exchangePayment": {
    "cardAuthorization": "Card authorization",
    "priceDifference": "Payment for price difference",
    "orderNotFound": "Order not found",
    "submitting": "Submitting...",
    "retrySubmit": "Retry Submit",
    "submitReturn": "Submit Return"
  },
  "resolutionConfirmation": {
    "gotIt": "Got it!",
    "gotItName": "Got it {name}!",
    "requested": "You've requested {resolution}."
  },
  "methodSelection": {
    "details": {
      "noBox": "No box needed",
      "noLabel": "No label needed",
      "ownBox": "Use your own box",
      "printLabel": "Print a pre-paid label",
      "ownLabel": "Attach your own shipping label"
    },
    "boxless": {
      "headline": "Happy Returns® - No box needed",
      "description": "Drop off your item(s) at a Happy Returns® location near you."
    },
    "labelless": {
      "headline": "Need a label printed",
      "description": "Box up your return at home. No label needed."
    },
    "labeled": {
      "headline": "Pre-paid label"
    },
    "none": {
      "headline": "Ship on your own",
      "description": "Return using your own label and shipping method."
    }
  },
  "locationSelection": {
    "title": "Select Drop-off Location",
    "intro": "Select a Happy Returns® drop-off location near you. Drop off your items without a box or label.",
    "showLess": "show less",
    "showMore": "show more",
    "distance": "{distance} mi",
    "seeAllLocations": "See all Happy Returns® locations",
    "privacyAgreement": "By using Happy Returns®, you agree to their {link}",
    "privacyPolicy": "Privacy Policy"
  },
  "hours": {
    "days": {
      "sun": "Sun",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat"
    },
    "openTodayUntil": "Open today until {time}",
    "opensOn": "Opens {day} at {time}",
    "closed": "Closed",
    "dayHours": "{days}: {hours}"
  },
  "instantResolution": {
    "title": "Receive Before You Ship",
    "allRequiredIntro": "You'll receive your resolution before shipping your return.",
    "youllReceive": "You'll receive:",
    "receiveNow": "Would you like to receive now?",
    "requiredHoldNotice": "You'll be asked to provide a payment method on the next step. A temporary hold will be placed until we receive your return. If the return is not received or expires, the hold will be charged.",
    "optionalHoldNotice": "If you opt in, you'll be asked to provide a payment method on the next step. A temporary hold will be placed until we receive your return. If the return is not received or expires, the hold will be charged.",
    "continue": "Continue"
  },
  "summary": {
    "title": "Here's a summary of your return. Does everything look correct?",
    "returnItems": "Return Items",
    "remove": "Remove",
    "reason": "Reason",
    "preference": "Preference",
    "exchangeFor": "Exchange for",
    "timing": "Timing",
    "instant": "Instant",
    "method": "Method",
    "shipOnYourOwn": "Ship on your own",
    "returnMethodFee": "Return Method Fee",
    "dropoffLocation": "Drop-off Location",
    "continueToPayment": "Continue to Payment"
  },
  "finalConfirmation": {
    "titlePending": "Your return request for #{number} is pending review",
    "titleInitiated": "Your return for #{number} has been initiated",
    "subtitle": "Return #{number}",
    "whatsNext": "What's next",
    "pendingReviewEmail": "We’ve received your return request and will review it. We’ll email {email} with a decision and next steps.",
    "waitForApproval": "Please wait for approval before shipping or dropping off your items.",
    "nextSteps": "Next steps",
    "shipBackBy": "Ship back your return items by {date}",
    "shippingInstructionsEmail": "We’ve sent a confirmation email to {email} with your shipping instructions.",
    "returnInstructions": "Return Instructions",
    "instructions": {
      "bringWithoutPackaging": "Bring your return item(s) without packaging",
      "showQrCode": "Show the QR code from your confirmation email",
      "dropOffAtHappyReturns": "Drop off at any Happy Returns® location",
      "repackage": "Carefully repackage the return item(s)",
      "printPackingSlip": "Print the packing slip and include it in your package",
      "shipToAddress": "Ship to the address below with your preferred carrier",
      "printLabel": "Print and attach pre-paid label to the box",
      "dropOffAtProvider": "Drop-off box to {carrier}",
      "dropOffAtCarrier": "Drop-off box to the carrier"
    },
    "dropoffLocation": "Drop-off Location",
    "findAllLocations": "Find all Happy Returns® locations",
    "dropoffRadius": "* Drop off within 50 miles of your shipping address",
    "returnAddress": "Return address",
    "printPackingSlip": "Print packing slip",
    "itemsToShipBack": "Items to be shipped back",
    "greatNews": "Great News!",
    "noNeedToReturn": "You don’t need to return the item(s). We hope that you donate or find a good home for them.",
    "creditItems": "{creditName} items",
    "confirmationEmail": "We’ve sent a confirmation email to {email}",
    "viewReturnStatus": "View return status"
  },
  "submitError": "An unexpected error occurred. Please try again.",
  "prefill": {
    "missingItem": "Item {id}",
    "missingItemsAlert": "The following items are no longer available:\n\n{items}\n\nPlease select items manually or contact support."
  }
}
